import {
    BUSINESS_VERIFICATION_COMPLETE_ID,
    REGISTER_YOUR_LLC_ID,
} from 'modules/common/components/Layout/LaunchpadTasks/useLaunchpadSchema/constants';
import UserType from 'modules/common/types/UserType.enum';

/**
 * Launchpad tasks that unlock health insurance, shared by the sidebar lock (menuAreas → useMenuAreas)
 * and the route guard (HealthInsurance) so the two can't drift.
 *
 * A member's launchpad schema carries at most one of these — formation members get
 * `register_your_llc`, takeover members get `business_verification_complete` — so gating on both is
 * self-selecting and needs no per-cohort branching at the call sites.
 */
export const HEALTH_INSURANCE_UNLOCK_TASKS = [REGISTER_YOUR_LLC_ID, BUSINESS_VERIFICATION_COMPLETE_ID];

const FORMATION_USER_TYPES: string[] = [UserType.SoleProprietor_LLC, UserType.SoleProprietor_SCorp];

/**
 * Hover copy while the sidebar entry is locked. Formation members are waiting on their business being
 * formed, takeover members on it being verified.
 */
export function getHealthInsuranceLockedTooltip(usertype?: string): string | undefined {
    if (!usertype) {
        return undefined;
    }
    return FORMATION_USER_TYPES.includes(usertype)
        ? 'Unlocked after your business is formed'
        : 'Unlocked after your business is verified';
}
